// extracted by mini-css-extract-plugin
export default {"container":"invoice_container__URbDN","mainContent":"invoice_mainContent__zw-s7","errorEditingModal":"invoice_errorEditingModal__R7hGY"};